import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user !== false) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      navigate("/admin", { replace: true });
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#FDFBF7]" data-testid="admin-login-page">
      <div className="absolute inset-0 opacity-30">
        <img
          src="https://images.pexels.com/photos/30585075/pexels-photo-30585075.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative w-full max-w-md bg-[#FDFBF7]/95 backdrop-blur-xl rounded-[2rem] p-10 sm:p-12 border border-[#5C6B5E]/15 shadow-xl">
        <p className="eyebrow mb-4">Admin-Bereich</p>
        <h1 className="font-display text-4xl text-[#2A332C] mb-8 leading-tight">
          Willkommen <span className="font-display-italic text-[#A66B56]">zurück</span>.
        </h1>
        <form onSubmit={handleSubmit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="eyebrow block mb-2">E-Mail</label>
            <input
              type="email"
              required
              className="input-elegant"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email"
            />
          </div>
          <div>
            <label className="eyebrow block mb-2">Passwort</label>
            <input
              type="password"
              required
              className="input-elegant"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password"
            />
          </div>
          {error && (
            <p className="text-sm text-red-700 bg-red-50 p-3 rounded-xl" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full"
            data-testid="admin-login-submit"
          >
            {loading ? "Wird angemeldet..." : "Anmelden"}
          </button>
        </form>
      </div>
    </div>
  );
}
